module.exports = __webpack_public_path__ + "static/media/service-motora.64984b9c.png";